import { defineStore } from 'pinia';
import { Subject } from 'rxjs';

export enum CallEventType {
  SOCKET_IO = 'SOCKET_IO',
  PEER_JS = 'PEER_JS',
  P2P_DATA_CONNECTION = 'P2P_DATA_CONNECTION',
  P2P_MEDIA_CONNECTION = 'P2P_MEDIA_CONNECTION',
}

export interface CallEvent {
  type: CallEventType;
  event: string;
  payload: any;
}

export const useCallEventStore = defineStore('callEvent', () => {
  const callEventTrigger = new Subject<CallEvent>();

  const emit = (callEventType: CallEventType, event: string, payload?: any) => {
    callEventTrigger.next({
      type: callEventType,
      event,
      payload,
    });
  };

  return {
    emit,
    callEventTrigger,
  };
});
